import React from 'react'
import View from './view'

const EventParticipant = ({ ...props }) => {
    return <View {...props} />
}

export default EventParticipant
